import { fireEvent } from '../tag-commander/datalayer';
import { surveyTrackingHasErrors } from './error';

export const trackQualtrics = (event: string) => {
  if (typeof window === 'undefined' || surveyTrackingHasErrors(event)) {
    return;
  }
  void fireEvent({
    event_category: `survey_event:${event}`,
  });
};
